// eslint-disable-next-line import-x/no-default-export
export default [
  ['INIT_QUESTIONS', 'liveId', 'presenterToken', 'doNotFetchQuestions'],
  'FETCH_QUESTIONS_SUCCESS',
  'FETCH_QUESTIONS_FAILURE',
  'FETCH_SINGLE_QUESTION_SUCCESS',
  ['DELETE_QUESTION', 'commentId'],
  ['ADD_QUESTION', 'values', 'formSubmitPromise'],
  'ADD_QUESTION_SUCCESS',
  'ADD_QUESTION_FAILURE',
  'RESET_QUESTIONS',
  'RESET_ADD_QUESTION_BUTTON_STATE',
  'INFINITE_LOAD_QUESTIONS',
  'INFINITE_LOAD_QUESTIONS_SUCCESS',
  'INFINITE_LOAD_QUESTIONS_FAILURE',
  'REALTIME_ADD_QUESTION',
  'OPTIMISTICALLY_ADD_QUESTION',
  'LEAVE_QUESTIONS',
  'WATCH_REALTIME_QUESTIONS',
  ['MOVE_QUESTION_COMMENT', 'fromIndex', 'toIndex'],
  ['OPTIMISTICALLY_UPDATE_QUESTION_COMMENTS', 'comments'],
  ['UPDATE_QUESTION_COMMENT', 'commentId', 'status'],
  'REALTIME_DATA_UPDATE',
  'REALTIME_REMOVE_COMMENT',
  'RESET_SCROLLING_PROPS',
  ['SET_SHOULD_SCROLL', 'shouldScroll'],
  ['SET_SCROLLING_INTENTION', 'scrollIntention'],
]
